import { render, staticRenderFns } from "./RestoreAccount.vue?vue&type=template&id=19a014d6&scoped=true&"
import script from "./RestoreAccount.vue?vue&type=script&lang=ts&"
export * from "./RestoreAccount.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreAccount.vue?vue&type=style&index=0&id=19a014d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a014d6",
  null
  
)

export default component.exports